/**
 * El reparto: retrato, nombre y descriptor de cada sospechoso.
 *
 * Con las salas en las columnas y las horas en las filas, el nombre de la persona ya no
 * cabe en ninguna cabecera: dentro de la casilla solo entra el retrato. Así que el
 * reparto tiene que estar a la vista en alguna parte, y este panel es esa parte. También
 * es donde el jugador aprende qué inicial corresponde a cada cara, que es lo que verá en
 * las anotaciones a lápiz.
 */

import { InitialBadge } from './InitialBadge';
import { Portrait } from '../design/Portrait';
import type { PersonVisual } from './visuals';

export function CastPanel({
  people,
  descriptors,
}: {
  people: readonly PersonVisual[];
  /** Descriptor breve por nombre, del pack de contenido («la médica del pueblo»). */
  descriptors: ReadonlyMap<string, string>;
}) {
  return (
    <section aria-labelledby="reparto-titulo" className="flex flex-col gap-3">
      <h2 id="reparto-titulo" className="font-display text-2xl">
        El reparto
      </h2>
      <ul className="grid grid-cols-2 gap-3 sm:grid-cols-3">
        {people.map((person) => (
          <li key={person.name} className="flex items-center gap-2">
            <span className="relative shrink-0">
              <Portrait portrait={person.portrait} size="sm" alt="" />
              <InitialBadge initials={person.initials} />
            </span>
            <span className="min-w-0 leading-tight">
              <span className="block truncate text-sm">{person.name}</span>
              <span className="text-text-muted block truncate text-xs">
                {descriptors.get(person.name) ?? ''}
              </span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
